import CreateAdminDialog from './createAdminDialog.container';

export default CreateAdminDialog;
